import React from "react";
import cx from "classnames";
import Attention from "../segment/Attention";
import BookingInfo from "../segment/BookingInfo";
import DisplayTypeCode from "../segment/DisplayTypeCode";
import HospitalInfo from "../segment/HospitalInfo";
import Line from "../segment/Line";
import NumbericalOrder from "../segment/NumbericalOrder";
import PatientInfo from "../segment/PatientInfo";
import ShortNotes from "../segment/ShortNotes";
import Status from "../segment/Status";
import Tagline from "../segment/Tagline";
import styles from "./style.module.scss";
import BookingStatus from "../segment/BookingStatus";
import { get, size } from "lodash";
import { getFormatMoney } from "~/utils/getFormatMoney";

const InformLayout = ({ informHtml, banner, keys }) => {
  return (
    <div className={styles.anounce_booking} key={keys}>
      <p
        className={styles.informBooking}
        dangerouslySetInnerHTML={{ __html: informHtml }}
      />
      {banner?.status ? (
        <a
          href={banner.url}
          className={styles.bannerInform}
          target={banner.cta.targetWeb}
        >
          <img
            src={banner.imageUrl}
            alt="inform"
            width={600}
            height={300}
            layout="responsive"
            objectFit="contain"
            objectPosition="center top"
            className={styles.imgInform}
          />
        </a>
      ) : null}
    </div>
  );
};

const DefaultLayout = ({ item, keys }) => {
  const { bookingInfo } = item;
  const showAttention = ![-2, 0, 6].includes(bookingInfo.status);
  const isTrungVuong = bookingInfo?.partnerId === "trungvuong";
  const addonServices = get(bookingInfo, "addonServices", []);
  const shortDescription = get(bookingInfo, "service.shortDescription", "");
  const height = get(bookingInfo, "height", "");
  const weight = get(bookingInfo, "weight", "");
  const isHeightWeight = height || weight;
  return (
    <>
      <Line top isTrungVuong={isTrungVuong} />
      {isTrungVuong && <BookingStatus bookingInfo={bookingInfo} />}
      <div className={styles.coupon} key={keys}>
        {/* Hospital Information */}
        <HospitalInfo bookingInfo={bookingInfo} isTrungVuong={isTrungVuong} />

        <div
          className={cx(
            styles.info,
            !bookingInfo?.displayCodeBooking?.value && styles.info1
          )}
          style={isTrungVuong ? { marginBottom: "0px" } : undefined}
        >
          {bookingInfo?.displayCodeBooking?.value && (
            <DisplayTypeCode bookingInfo={bookingInfo} />
          )}
          <NumbericalOrder bookingInfo={bookingInfo} />
        </div>
        {shortDescription && (
          <div dangerouslySetInnerHTML={{ __html: shortDescription }} />
        )}
        {!isTrungVuong && <Status bookingInfo={bookingInfo} />}
        <ShortNotes bookingInfo={bookingInfo} isTrungVuong={isTrungVuong} />
        <Line />
        <BookingInfo bookingInfo={bookingInfo} />
        <PatientInfo bookingInfo={bookingInfo} />

        {/* Chỉ số sức khỏe */}
        {isHeightWeight && (
          <>
            <Line />
            <ul className={styles.listInfo}>
              <p style={{ fontWeight: 700, marginBottom: 10 }}>
                Chỉ số sức khỏe:{" "}
              </p>
              <div>
                <li>
                  <span className={styles.column_left}>Cân nặng:</span>
                  <b className={styles.column_right}>{weight} kg</b>
                </li>
                <li>
                  <span className={styles.column_left}>Chiều cao:</span>
                  <b className={styles.column_right}> {height} cm</b>
                </li>
              </div>
            </ul>
          </>
        )}

        {/* Các dịch vụ addons */}
        {size(addonServices) > 0 && (
          <>
            <Line />
            <ul className={styles.listInfo}>
              <p style={{ fontWeight: 700, marginBottom: 10 }}>
                Các dịch vụ khác:{" "}
              </p>
              <div>
                {addonServices.map((v, i) => {
                  return (
                    <li key={i}>
                      <span className={styles.column_left}>{v?.name}:</span>
                      <b className={styles.column_right}>
                        {v.price === 0
                          ? v?.priceText
                          : getFormatMoney(v.price) + " VNĐ"}
                      </b>
                    </li>
                  );
                })}
              </div>
            </ul>
          </>
        )}
        {showAttention && (
          <>
            <Line />
            <Attention bookingInfo={bookingInfo} />
          </>
        )}

        <Tagline />
        <Line bottom />
      </div>
    </>
  );
};

const Coupon = ({ item, keys }) => {
  if (!item) return null;

  const { layout } = item;

  switch (layout) {
    case "INFORM":
      return <InformLayout {...item} keys={keys} />;
    default:
      return <DefaultLayout item={item} keys={keys} />;
  }
};

export default Coupon;
